<template>
      <a
        href="javascript:;"
        @click="rePrintRequest(item)"
        class="btn btn-info add-to-cart btn-sm"
        >
        <i v-if="icon" class="fa fa-print"></i> 
        Reprint Request</a
      >
  </template>
  <script>
  export default {
    props: ["item", "icon"],
    methods: {
      async rePrintRequest(row) {
        if (!localStorage.getItem("token")) {
          localStorage.setItem("redirectUrl", "/");
          location.href = "/login";
        }
  
        let formData = {
          user_id: localStorage.getItem("user_id"),
          product_id: row.id,
        };
  
        try {
          const response = await this.$http.post("reprint-request", formData);
          if (response.data.status) {
            this.flashMessage.success({
              message:
                "Your request has been added successfully. We will contact you shortly.",
            });
          } else {
            this.flashMessage.error({ message: response.data.message });
          }
        } catch (error) {
          console.log(error);
        }
      },
    },
  };
  </script>
  